import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { oregonCityConfig } from "./data";

export default function OregonCityPage() {
  return <OregonCityPageTemplate config={oregonCityConfig} />;
}